import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithClient } from "@/redux/baseQuery";
import { ListPastReceiptsRawResponse, PastReceipt } from "./types";

/**
 * Consolidated monthly receipts (PDF "consolidated invoices") via the v3 client wrapper
 * (Client\V3\Rest\Invoice, DEV-1138) — the same data mobile still reads from the legacy
 * /v2/invoice resource (app-customer src/redux/apis/invoice); payload shapes are identical.
 */
export const clientReceiptsApi = createApi({
  reducerPath: "clientReceiptsApi",
  baseQuery: baseQueryWithClient(),
  tagTypes: ["ClientReceipts"],
  endpoints: (builder) => ({
    listPastReceipts: builder.query<PastReceipt[], { accountId?: string } | void>({
      // returns the rolling 12-month list unpaginated
      query: (arg) => ({ url: "/invoice", accountId: arg?.accountId }),
      transformResponse: (response: ListPastReceiptsRawResponse) => response?._embedded?.invoice ?? [],
      providesTags: ["ClientReceipts"],
    }),
    getReceiptPdf: builder.query<PastReceipt, { id: string; accountId?: string }>({
      query: ({ id, accountId }) => ({ url: `/invoice/${id}`, accountId }),
      // the response carries a whole base64 PDF — don't keep it in the store after download
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useListPastReceiptsQuery, useLazyGetReceiptPdfQuery } = clientReceiptsApi;
